export default Object.freeze({
  RELEVANT: 'RELEVANT',
  NOT_RELEVANT: 'NOT_RELEVANT',
  NOT_SURE: 'NOT_SURE',
  UNSCREENED: 'UNSCREENED',
});
